import { FieldArrayFieldsProps } from "redux-form/lib/FieldArray"
import { TitledLink } from "../../../types"
import { RcFile } from "antd/es/upload"

export const toFileDragAndDropValue = (
  fields: FieldArrayFieldsProps<TitledLink>
): {
  fileList: RcFile[]
} => {
  const fileList: RcFile[] = fields.getAll().map((field) => ({
    ...new File([], field.title),
    uid: field.url,
    lastModifiedDate: new Date(),
  }))

  return {
    fileList,
  }
}
